




















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { SimpleProcess } from '@attensi/api-js';

import ProcessListElement from './ProcessListElement.vue';
import ProcessListFilter from './ProcessListFilter.vue';

@Component({ components: { ProcessListElement, ProcessListFilter } })
export default class ProcessList extends Vue {
  logoPath: string = '';

  @Action('processModule/setProcesses') setProcesses!: Function;

  @Getter('processModule/processes') processes!: SimpleProcess[];
  @Getter('processModule/isListProcessing') isListProcessing!: boolean;

  async created() {
    try {

      const company = await this.$portal.getCompaniesCurrent().then((resp) => resp.data);
      this.logoPath = company.logo;

      this.$api.setOptions({
        companyNameKey: company.name_key,
      });

      const processess = await this.$creator.getProcesses().then((resp) => resp.data);
      this.setProcesses(processess);


    } catch (err) {
      throw err;
    }
  }

  @Action('processModule/getProcesses') getProcesses!: Function;
}
